module.exports = __webpack_public_path__ + "img/retrofit-details-2.b281a30c.png";